module.exports = __webpack_public_path__ + "assets/flex-logo-white.dca61261.svg";